import React from 'react';
import moment from 'moment';

import { Link } from 'react-router';
import { Button, Table } from 'react-bootstrap';
import Loading from '../Loading';
import BillingActions from '../../actions/BillingActions';
import BillingGroupStore from '../../stores/BillingGroupStore';
import CardForm from '../Payment/CardForm';
import ClientServiceStore from '../../stores/ClientServiceStore';
import ClientStore from '../../stores/ClientStore';
import PaymentTokenStore from  '../../stores/PaymentTokenStore';
import ServiceActions from '../../actions/ServiceActions';
import TokenActions from '../../actions/TokenActions';
import UserStore from '../../stores/UserStore';

function getState() {
    return {
        billingGroups: BillingGroupStore.get() || [],
        newCard: PaymentTokenStore.getNewCard(),
        services: ClientServiceStore.get() || [],
        tokens: PaymentTokenStore.get() || [],
        tokenUsageMap: PaymentTokenStore.tokenUsageMap,
        loading: ClientStore.loading(),
        roles: UserStore.getCurrentRoles() || [],
        savingBillingToken: BillingGroupStore._savingToken,
        savingNewCard: PaymentTokenStore._savingNewCard,
        tokenBeingDeleted: PaymentTokenStore._deletingToken
    }
}

var PaymentMethodsView = React.createClass({
    componentDidMount: function() {
        TokenActions.updateCard(null);
        PaymentTokenStore.addChangeListener(this.update);
        BillingGroupStore.addChangeListener(this.update);
    },
    componentWillMount: function () {
        ServiceActions.getServices();
    },
    componentWillUnmount: function () {
        BillingGroupStore.removeChangeListener(this.update);
        PaymentTokenStore.removeChangeListener(this.update);
    },
    getInitialState: function () {
        return {loading: true};
    },
    deleteToken: function (token) {
        TokenActions.delete(token);
    },
    updateSelectedToken: function (bg, token) {
        BillingActions.updateToken(bg, token);
    },
    handleChangeForMultiBillingGroupTable: function (bg) {
        let select = this.refs['bg-card-' + bg.id];
        let token = null;

        this.state.tokens.forEach(t => {
            if (t.uuid === select.getDOMNode().value) {
                token = t;
            }
        });

        BillingActions.updateToken(bg, token);
    },
    handleNewCardSave: function () {
        let billingGroupDefaults = [];
        let that = this;

        this.state.billingGroups.map(bg => {
            if (that.refs['nc-default-'+bg.id] && that.refs['nc-default-'+bg.id].getDOMNode().checked) {
                billingGroupDefaults.push(bg.id);
            }
        });

        TokenActions.save((token) => {
            TokenActions.updateCard(null);
            this.state.billingGroups.map(bg => {
                if (that.refs['nc-default-'+bg.id]) {
                    that.refs['nc-default-'+bg.id].getDOMNode().checked = false;
                }
            });
        }, billingGroupDefaults);
    },
    render: function () {
        if (this.state.loading) {
            return <Loading />;
        }

        let singleBillingGroup = this.state.billingGroups.length === 1 ? this.state.billingGroups[0] : null;

        return <section id="payment-tokens">
            <h1>Manage Saved Cards</h1>
            <div className="callout callout-info">
                <p>Do you have any domains registered with Infinite Networks? Your credit card may also be saved in our <a href="https://infinite.partnerconsole.net/" target="_blank">domains portal</a>. Make sure to update your credit card there when necessary.</p>
            </div>
            <div>
                <div className="row">
                    <div className="col-md-6">
                        <h2>Saved Cards</h2>
                        <div className="table-responsive">
                            {this.renderSavedCardTable(singleBillingGroup)}
                            <p><em>In this table you can remove old cards and select which card you want to use for automatic payments.</em></p>
                        </div>
                    </div>
                    {singleBillingGroup && this.state.services.length > 1 && <div className="col-md-6">
                        <h2>Billing Groups</h2>
                        <p>Do you need different services to be charged to different credit cards, or invoices to be sent to different email addresses?</p>
                        <p><Link to="support">Contact support</Link> to set up billing groups.</p>
                    </div>}
                    {!singleBillingGroup && <div className="col-md-6">
                        <h2>Billing Groups</h2>
                        {this.renderBillingGroupTable()}
                    </div>}
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <h2>Add a New Card</h2>
                        {this.renderNewCardForm(singleBillingGroup)}
                    </div>
                </div>
            </div>
        </section>;
    },
    renderSavedCardTable: function (singleBillingGroup) {
        return <Table className="table-striped table-hover">
            <thead>
            <tr>
                {singleBillingGroup && <th style={{width: 120}}>Auto pay</th>}
                <th>Card</th>
                {!singleBillingGroup && <th>Billing Groups</th>}
                <th style={{width: 170}}>Actions</th>
            </tr></thead>
            <tbody>
            {this.state.tokens.map(token => {
                const usage = this.state.tokenUsageMap[token.uuid] || [];
                const deleting = this.state.tokenBeingDeleted && this.state.tokenBeingDeleted.uuid === token.uuid;
                const settingAsDefault = this.state.savingBillingToken && this.state.savingBillingToken.tokenUuid === token.uuid;
                return <tr key={'payment-method-view-'+token.uuid}>
                    {singleBillingGroup && <td>
                        <label><input type="radio" name="token" checked={token.uuid === singleBillingGroup.payment_token} onChange={() => this.updateSelectedToken(singleBillingGroup, token)} /> Auto pay</label>
                        {' '}
                        {settingAsDefault && <Loading message="" />}
                    </td>}
                    <td>
                        <i className="fa fa-credit-card"></i> <span className="card">{token.card.number}</span><br />
                        <small className="low">{token.card.name}</small><br />
                        <small className="low expires">Expires: {moment(token.card.expiry).format('MM/YY')}</small>
                    </td>
                    {!singleBillingGroup && <td>
                        {usage.map(bgName => <div key={'payment-method-view-'+token.uuid+'-'+bgName}>{bgName}</div>)}
                    </td>}
                    <td>
                        {usage.length === 0 && <Button onClick={() => this.deleteToken(token)} bsStyle="danger" disabled={settingAsDefault}>
                            {deleting ? <Loading message="" /> : <i className="fa fa-trash"></i>}
                            {' '}DELETE
                        </Button>}
                    </td>
                </tr>;
            })}
            </tbody>
            {singleBillingGroup && !singleBillingGroup.token_required && <tfoot>
                <tr>
                    <td colSpan="3">
                        <label><input type="radio" name="token" checked={!singleBillingGroup.payment_token} onChange={() => this.updateSelectedToken(singleBillingGroup, null)} /> Disable automatic payments</label>
                        {' '}
                        {this.state.savingBillingToken && this.state.savingBillingToken.tokenUuid === null && <Loading message="" />}
                    </td>
                </tr>
            </tfoot>}
        </Table>;
    },
    renderNewCardForm: function (singleBillingGroup) {
        let buttonIcon = <i className="fa fa-credit-card"></i>;

        if (this.state.savingNewCard) {
            buttonIcon = <Loading message="" />;
        }

        return <form className="form-horizontal" onSubmit={(e) => { e.preventDefault(); this.handleNewCardSave(); }}>
            <CardForm
                card={this.state.newCard}
                ref="newCard"
                handleUpdate={TokenActions.updateCard}
                horizontal={[3,9]}
                showNotice={false}
                showSaveCard={false}
                violations={this.state.cardErrors}
            />
            {singleBillingGroup && <div className="form-group">
                <div className="col-md-3"></div>
                <div className="col-md-9">
                    <label>
                        <input
                            ref={'nc-default-' + singleBillingGroup.id}
                            type="checkbox"
                            defaultChecked={true}
                        /> Use for automatic payments
                    </label>
                </div>
            </div>}
            {!singleBillingGroup && <div className="form-group">
                <div className="col-md-3"></div>
                <div className="col-md-9">
                    {this.state.billingGroups.map(bg => <div key={'bg-default-'+bg.id}>
                        <label>
                            <input
                                ref={'nc-default-' + bg.id}
                                type="checkbox"
                                defaultChecked={true}
                            /> Use for automatic payments for {bg.name}
                        </label>
                    </div>)}
                </div>
            </div>}
            <div className="form-group">
                <div className="col-md-3"></div>
                <div className="col-md-9">
                    <Button bsStyle="success" type="submit">
                        {buttonIcon} Save Card
                    </Button>
                </div>
            </div>
        </form>;
    },
    renderBillingGroupTable: function () {
        return <Table className="table-striped table-hover">
            <thead><tr>
                <th>Billing Group</th>
                <th>Card for automatic payments</th>
            </tr></thead>
            <tbody>
                {this.state.billingGroups.map(bg => {
                    const saving = this.state.savingBillingToken && this.state.savingBillingToken.billingGroup === bg;
                    return <tr key={'bg-row-'+bg.id}>
                        <td>
                            {bg.name}
                            {' '}
                            {saving && <Loading message="" />}
                        </td>
                        <td>
                            <select className="form-control input-md"
                                    ref={'bg-card-' + bg.id}
                                    defaultValue={bg.payment_token}
                                    onChange={() => this.handleChangeForMultiBillingGroupTable(bg)}
                                    disabled={saving}
                            >
                                {this.state.tokens.map(token => <option value={token.uuid} key={token.uuid}>
                                    {token.card.number} ({moment(token.card.expiry).format('MM/YY')})
                                </option>)}
                                {!bg.token_required && <option value="">
                                    No automatic payments
                                </option>}
                            </select>
                        </td>
                    </tr>;
                })}
            </tbody>
        </Table>;
    },
    update: function () {
        this.setState(getState());
    }
});
module.exports = PaymentMethodsView;



// WEBPACK FOOTER //
// ./app/components/Accounting/PaymentMethodsView.js